'use strict';

var helper = require('../helper');

module.exports = {
    // 6.116 REFUND OPTION - MOTIVATION SELECT
    pushRefundOptionMotivationSelect (motivation, sku) {
        if (!motivation || !sku) {
            return;
        }

        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '115',
            'eventname': 'return',
            'step': 'motivation_select',
            'text': motivation,
            'product_id': sku
        };
        helper.log('Pushing refund option motivation select interaction!', true);
        helper.push(pushObject);
    },

    // 6.117 REFUND OPTION - SHIPPING METHOD
    pushRefundOptionShippingMethod (shippingMethod, skus) {
        if (!shippingMethod || !skus) {
            return;
        }

        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '41',
            'eventname': 'return',
            'step': 'shipping_select',
            'shipping_method': shippingMethod,
            'product_id': skus
        };
        helper.log('Pushing refund option shipping method interaction!', true);
        helper.push(pushObject);
    },

    // 6.118 REFUND OPTION - PAYMENT METHOD
    pushRefundOptionPaymentMethod (paymentMethod, skus) {
        if (!paymentMethod || !skus) {
            return;
        }

        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '116',
            'eventname': 'return',
            'step': 'payment_select',
            'payment_method': paymentMethod,
            'product_id': skus

        };
        helper.log('Pushing refund option payment method interaction!', true);
        helper.push(pushObject);
    },

    pushRefundOptionConfirmation (skus, shippingMethod, paymentMethod, transactionID) {
        if (!skus || !shippingMethod || !paymentMethod) {
            return;
        }

        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '117',
            'eventname': 'return_confirmation',
            'step': 'confirmation',
            'order': transactionID,
            'product_id': skus,
            'shipping_method': shippingMethod,
            'payment_method': paymentMethod
        };
        helper.log('Pushing refund option confirmation interaction!', true);
        helper.push(pushObject);
    }
};
